import React, { Component } from "react";

//resources
import '../../App.css'; //Verificar el import de este CSS

//Contiene la bar UI del buscador y manda la busqueda a travez de un link
class Search extends Component {

    //Heredar estado de header

    //Modifica el estado global
    
    render() {
        const { handleSearch } = this.props;
        const { handleSearchingFocus } = this.props;
        const { busqueda } = this.props; //Se captura para mostrar el valor en el input

        return(
            <div className="d-flex justify-content-center clubes--search-container">
                <input type="text" placeholder="Buscar" className="clubes--search" name="busqueda"
                onChange={handleSearch}
                onFocus={handleSearchingFocus}
                value={busqueda}/>
                <span className="clubes--icon-search"></span>
           </div>
        );
    }
}

export default Search;